import { SortAscendingOutlined, SortDescendingOutlined, SwapOutlined } from "@ant-design/icons"
import { Button, Dropdown, Menu } from "antd"
import { SortEnum, SortCompanyEnum } from "Features/settings/companySettings/companyList"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { getPopupAnchor } from "Shared/utils"
import useDebouncedCallback from "use-debounce/lib/useDebouncedCallback"

interface SortStateInterface {
    direction: SortEnum
    field: SortCompanyEnum
}

interface CompanyListSortInterface {
    currentSort: SortStateInterface
    onClick: (direction: SortEnum, field: SortCompanyEnum) => void
}

function CompanyListSort({ currentSort, onClick }: CompanyListSortInterface) {
    const { t } = useTranslation()

    const [isDropdownShowing, setIsDropdownShowing] = useState(false)

    const values = [
        {
            field: SortCompanyEnum.NAME,
            direction: SortEnum.ASC,
            path: "company_name",
        },
        {
            field: SortCompanyEnum.NAME,
            direction: SortEnum.DESC,
            path: "company_name",
        },
        {
            field: SortCompanyEnum.DATE,
            direction: SortEnum.ASC,
            path: "date_created",
        },
        {
            field: SortCompanyEnum.DATE,
            direction: SortEnum.DESC,
            path: "date_created",
        },
    ]

    const updateSorting = (direction: SortEnum, field: SortCompanyEnum) => {
        const same = direction === currentSort.direction && field === currentSort.field
        if (!same) onClick(direction, field)
    }

    const delayedSortingUpdate = useDebouncedCallback((direction: SortEnum, field: SortCompanyEnum) => {
        updateSorting(direction, field)
    }, 350)

    return (
        <div>
            <Dropdown
                overlayClassName="rounded"
                visible={isDropdownShowing}
                onVisibleChange={(show: boolean) => setIsDropdownShowing(show)}
                trigger={["click"]}
                getPopupContainer={getPopupAnchor()}
                overlay={
                    <Menu className="z-20 user-dropdown" selectedKeys={[`${currentSort.field}_${currentSort.direction}`]}>
                        {values.map(({ field, path, direction }) => (
                            <Menu.Item
                                mode="horizontal"
                                className="flex items-center"
                                key={`${field}_${direction}`}
                                icon={direction === SortEnum.ASC ? <SortAscendingOutlined /> : <SortDescendingOutlined />}
                                onClick={() => delayedSortingUpdate.callback(direction, field)}
                            >
                                <div className="flex items-center gap-5">
                                    <span>{t(`label:${path}`)}</span>
                                </div>
                            </Menu.Item>
                        ))}
                    </Menu>
                }
            >
                <Button>
                    <SwapOutlined rotate={90} />
                </Button>
            </Dropdown>
        </div>
    )
}

export default CompanyListSort
